import React from 'react';
import IndianRidersContainer from '../features/indian-riders';

const IndianRidersTimeline: React.FC = () => {
  return <IndianRidersContainer />;
};

export default IndianRidersTimeline;